import { Line } from "react-chartjs-2";
import React, { useEffect, useState } from "react";
import { dateFormatDateTime } from "@/utils";
// import { dateFormatDateTimeApi } from "../../../utils";
// import { useGetCounterDataMutation } from "../../../redux/reservationApi";

const getData = ({ data }) => {
    // console.log(data);

    const labels = data?.map((i) => i.label);
    const values = data?.map((i) => i.value);

    return {
        labels: labels,
        datasets: [
            {
                type: "bar",
                label: "유형별 가동률",
                data: values,
                fill: true,
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;

                    if (!chartArea) {
                        return null;
                    }

                    const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                    // gradient.addColorStop(0, "rgba(255, 255, 255, 0)");
                    // gradient.addColorStop(0.4, "#5E77F9");
                    gradient.addColorStop(0.8, "#5E77F9");
                    gradient.addColorStop(1, "#5E77F9");
                    // gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
                    return gradient;
                },
                borderColor: "#5E77F9",
                tension: 0.1,
                pointBackgroundColor: "#fff",
                pointBorderColor: "#5E77F9",
                pointHoverBackgroundColor: "#5E77F9",
                pointHoverBorderColor: "#5E77F9",
            },
        ],
    };
};

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        tooltip: {
            usePointStyle: true,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderColor: "#ddd",
            borderWidth: 1,
            cornerRadius: 14,
            padding: 10,
            displayColors: false,
            titleColor: "#888",
            titleFont: {
                family: "Pretendard",
                size: 12,
                style: "normal",
                weight: "normal",
            },
            bodyColor: "#000",
            bodyFont: {
                family: "Pretendard",
                size: 32,
                style: "normal",
                weight: "bold",
            },
            callbacks: {
                title: function (tooltipItems) {
                    const date = tooltipItems[0].label;
                    return `${date}`;
                },
                label: function (context) {
                    return `${context.parsed.y} %`;
                },
            },
            // 사용자 정의 툴팁을 사용하여 툴팁 화살표 스타일 적용

            external: function (context) {
                let tooltipEl = document.getElementById("chartjs-tooltip");
                if (!tooltipEl) {
                    tooltipEl = document.createElement("div");
                    tooltipEl.id = "chartjs-tooltip";
                    tooltipEl.innerHTML = "<table></table>";
                    document.body.appendChild(tooltipEl);
                }

                const tooltipModel = context.tooltip;
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                }

                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                    return bodyItem.lines;
                }

                if (tooltipModel.body) {
                    const titleLines = tooltipModel.title || [];
                    const bodyLines = tooltipModel.body.map(getBody);

                    let innerHtml = "<thead>";

                    titleLines.forEach(function (title) {
                        innerHtml += `<tr><th>${title}</th></tr>`;
                    });
                    innerHtml += "</thead><tbody>";

                    bodyLines.forEach(function (body, i) {
                        const colors = tooltipModel.labelColors[i];
                        let style = `background:${colors.backgroundColor}`;
                        style += "; border-width: 2px";
                        const span = `<span class="chartjs-tooltip-key" style="${style}"></span>`;
                        innerHtml += `<tr><td>${span}${body}</td></tr>`;
                    });
                    innerHtml += "</tbody>";

                    const tableRoot = tooltipEl.querySelector("table");
                    tableRoot.innerHTML = innerHtml;
                }

                const position = context.chart.canvas.getBoundingClientRect();

                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + "px";
                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + "px";
                tooltipEl.style.padding = tooltipModel.padding + "px " + tooltipModel.padding + "px";
                tooltipEl.style.pointerEvents = "none";
                tooltipEl.style.background = tooltipModel.options.backgroundColor;
                tooltipEl.style.borderRadius = tooltipModel.options.cornerRadius + "px";
                tooltipEl.style.borderColor = tooltipModel.options.borderColor;
                tooltipEl.style.borderWidth = tooltipModel.options.borderWidth + "px";
                tooltipEl.style.color = tooltipModel.options.bodyColor;
            },
        },
        legend: {
            display: false,
            labels: {
                font: {
                    family: "Pretendard",
                    size: 14,
                    style: "normal",
                    weight: "100",
                },
            },
        },
    },
    scales: {
        x: {
            title: {
                display: false,
                text: "요일",
                font: {
                    family: "Pretendard",
                    size: 14,
                    style: "normal",
                    weight: "100",
                },
            },
            grid: {
                display: false,
            },
            ticks: {
                font: {
                    family: "Pretendard",
                    size: 14,
                    weight: "100",
                },
            },
        },
        y: {
            title: {
                display: false,
                text: "접수율",
                font: {
                    family: "Pretendard",
                    size: 14,
                    style: "normal",
                    weight: "100",
                },
            },
            beginAtZero: true,
            max: 100,
            ticks: {
                stepSize: 100,
                font: {
                    family: "Pretendard",
                    size: 14,
                },
            },
        },
    },
};

export const CustomChart = ({ clientId, startedAt, endedAt }) => {
    const [chartData, setChartData] = useState(
        getData({
            data: [
                { label: "사고대차", value: "16" },
                { label: "장기렌트", value: "87" },
            ],
        })
    );

    useEffect(() => {
        // console.log(chartData);
    }, [chartData]);

    useEffect(() => {
        // getCounterData({
        //     clientId,
        //     startedAt: startedAt && dateFormatDateTimeApi(startedAt),
        //     endedAt: endedAt && dateFormatDateTimeApi(endedAt),
        // });
    }, [clientId, startedAt, endedAt]);

    // const [getCounterData, { data: countData, error: countError, isLoading: countLoading }] = useGetCounterDataMutation();

    // useEffect(() => {
    //     console.log(countData);
    //     console.log({
    //         v: (countData?.data?.finishedReservationCount * 100) / countData?.data?.totalReservationCount,
    //         f: (countData?.data?.reservedSmsCount * 100) / countData?.data?.totalSmsCount,
    //     });
    //     const reservationRate = (countData?.data?.finishedReservationCount * 100) / countData?.data?.totalReservationCount;
    //     const smsReserveRate = (countData?.data?.reservedSmsCount * 100) / countData?.data?.totalSmsCount;

    //     const viewData = {
    //         data: [
    //             { label: "예약접수율", value: smsReserveRate },
    //             { label: "점검완료율", value: reservationRate },
    //         ],
    //     };

    //     setChartData(getData(viewData));
    // }, [countData]);

    return (
        <>
            <section className="chart-content" data-develop="false">
                <div className="section-head">
                    <span className="head-tab">
                        <button type="button" className="btn-tab active">
                            유형별 가동률 ({dateFormatDateTime(new Date(), "YYYY.MM.DD")})
                        </button>
                        {/*<button type="button" className="btn-tab">*/}
                        {/*    점검 완료율*/}
                        {/*</button>*/}
                    </span>
                </div>
                <div className="section-content">
                    <div className="chart-wrapper">
                        <Line data={chartData} options={chartOptions} className="chart" />
                    </div>
                </div>
            </section>
        </>
    );
};
